import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=1326e252&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=1326e252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1326e252",
  null
  
)

export default component.exports